import { eventSlice } from './eventSlice';

export const {
  setActiveEventId,
  clearPinValue,
  addLastCallQuest,
  addAudience,
  addUserToAudience,
  demoteUserToAudience,
  removeUserFromAudience,
  setDisconnectedParticipants,
  clearStageInvitation,
  setCloudPlayer,
  setUserHandRaisedForUser,
  addRoom,
  removeRoom,
  addParticipantsWithRaisedHand,
  removeParticipantsWithRaisedHand,
  toggleShowAudienceList,
  setActivePanelTab,
  hideTranscriptionModal,
  updateRoom,
  setActiveSpeakersIds,
  setEventState,
  toggleRoomHelpCenter,
  setRematchCountdown,
  setNatteringResumeCountdown,
  setMatchingTeleprompterMounted,
} = eventSlice.actions;
